import React, { useState } from 'react'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import RazorpayDetails from './RazorpayDetails'
import PayPalDetails from './PaypalDetails'

pdfMake.vfs = pdfFonts as unknown as typeof pdfMake.vfs

const PaymentDetailsPage = () => {
  const [selectedGateway, setSelectedGateway] = useState('razorpay')

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header d-flex justify-content-between align-items-center'>
        <h3>Payment Details History</h3>
        <select
          className='form-select w-auto'
          value={selectedGateway}
          onChange={(e) => setSelectedGateway(e.target.value)}
        >
          <option value='razorpay'>Razorpay Details</option>
          <option value='paypal'>PayPal Details</option>
        </select>
      </div>
      <div className='card-body'>
        {selectedGateway === 'razorpay' ? <RazorpayDetails /> : <PayPalDetails />}
      </div>
    </div>
  )
}

export default PaymentDetailsPage
